import { isVimeoRedirectableUrl } from '../../../libs/isVimeoRedirectableUrl';

interface SSOData {
  SSO: boolean;
  checkInProgress: boolean;
  connection: string;
  firstTimeSSOLogin: boolean;
  customDomain?: string;
  prevPage: string | null;
  showEnterpriseOptInConsent: boolean;
  bypassSSO: boolean;
}

function validateEmail(email: string) {
  const regex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
}

const shouldBypassSSO = () => {
  if (typeof window !== 'undefined' && window.frameElement) {
    const referrer = document.referrer;
    return referrer.indexOf('bypass_sso=true') >= 0;
  }
  const params = typeof window !== 'undefined' && new URLSearchParams(window.location.search);
  const bypassSSOParam = params && decodeURIComponent(params?.get('bypass_sso') || '');
  return bypassSSOParam === 'true';
};

export const ssoDataInitialState: SSOData = {
  SSO: false,
  checkInProgress: false,
  connection: '',
  firstTimeSSOLogin: false,
  customDomain: '',
  prevPage: null,
  showEnterpriseOptInConsent: false,
  bypassSSO: shouldBypassSSO(),
};

export const loginViaSSO = (connectionUrl: string, redirectUrl?: string, customDomain?: string) => {
  const prevPage =
    redirectUrl && isVimeoRedirectableUrl(redirectUrl)
      ? new URL(redirectUrl, window.location.origin).href
      : window.location.href;

  const csrfToken = window.vimeo?.xsrft || '';

  const ssoLoginPath =
    (customDomain || '') +
    '/auth0/connect?connection=' +
    connectionUrl +
    '&prev_page=' +
    encodeURIComponent(prevPage) +
    '&token=' +
    encodeURIComponent(csrfToken);
  window.location.assign(ssoLoginPath);
};

export const validateSSOEmail = async (email: string, updateSsoData: (data: SSOData) => void) => {
  if (!email) {
    updateSsoData(ssoDataInitialState);
    return;
  }
  try {
    updateSsoData({ ...ssoDataInitialState, checkInProgress: true });

    if (validateEmail(email)) {
      const response = await fetch(`/sso_domains/validate/${email}`);
      const data = await response.json();

      updateSsoData({
        SSO: data.is_valid,
        connection: data.sso_domain.sso_connection,
        checkInProgress: false,
        firstTimeSSOLogin: data.first_time_sso_login,
        customDomain: data?.custom_domain || '',
        prevPage: data.prev_page,
        showEnterpriseOptInConsent: data.show_enterprise_opt_in_consent,
        bypassSSO: shouldBypassSSO(),
      });
    } else {
      updateSsoData(ssoDataInitialState);
    }
  } catch (e) {
    updateSsoData(ssoDataInitialState);
  }
};
